import { HttpClient } from '../../httpClient'
import type {
  OpalApiRequestBody,
  OpalApiRequestParams,
  OpalApiResponseDocument,
} from '../../schema'

type UpdateWorkspaceDefaultsV3Params =
  OpalApiRequestParams<'UpdateWorkspaceDefaultsV3'>
type UpdateWorkspaceDefaultsV3RequestBody =
  OpalApiRequestBody<'UpdateWorkspaceDefaultsV3'>
type UpdateWorkspaceDefaultsV3Response = OpalApiResponseDocument<
  'UpdateWorkspaceDefaultsV3',
  200
>

export const updateWorkspaceDefaults = async (
  params: UpdateWorkspaceDefaultsV3Params,
  requestBody: UpdateWorkspaceDefaultsV3RequestBody
): Promise<UpdateWorkspaceDefaultsV3Response> => {
  const workspaceDefaultsId = params.path.workspace_defaults_id
  const url = new URL(
    `/workspaces/v3/workspace_defaults/${workspaceDefaultsId}`,
    window.location.origin
  )

  return HttpClient()
    .patch(url.toString(), requestBody)
    .then((res) => res.data)
}
